import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Locale, formatDuration } from 'date-fns';
import { enGB, fr, nl } from 'date-fns/locale';

const LOCALES: Record<string, Locale> = { '1': nl, '2': fr, '3': enGB };

@Pipe({
    name: 'formatInMonths',
    standalone: false
})
export class FormatInMonthsPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);
  transform(months: number | undefined): string {
    let [, languageId] = this.translateService.currentLang.split('_');
    if (!languageId) languageId = '1';
    if (!months) return '';
    return formatDuration({ months }, { locale: LOCALES[languageId] });
  }
}
